

<loading [isLoading]="isLoading" [isFullSize]="true"></loading>
<map></map>
<div>

  <!-- notificaciones de sistema y texto para tooltip -->
  <system-notification class="system-notification"></system-notification>
  <app-tooltip *ngIf="this.toolCarSelectorService.isCarSelectionToolTipVisible" class="tooltip-container" [Mensaje]="intersectMsg" [isVisible]="this.toolCarSelectorService.isCarSelectionToolTipVisible" (visibilityChange)="onToolTipVisibilityChange($event)"></app-tooltip>

  <!-- handle de arrastre para capas -->
  <div class="layers-buttons-container box" cdkDrag>
    <panel-internal-layers class="button-container"></panel-internal-layers>
    <panel-external-layers [ngClass]="{'disabled': layerService.isExternalLayersButtonDisabled}" class="button-container"></panel-external-layers>
    <panel-map-layers [ngClass]="{'disabled': layerService.isMapLayersButtonDisabled}" class="button-container"></panel-map-layers>
  </div>

  <!-- handle de arrastre para herramientas -->
  <div class="tools-buttons-container box" cdkDrag>
    <tool-cars-selector class="button-container"></tool-cars-selector>
    <tool-street-info-box class="button-container"></tool-street-info-box>
  </div>

  <!-- panel de lugares concurridos -->
  <!-- <div class="recurrent-container" cdkDrag>
    <recurrent-places *ngIf="geoClustersFrecuencyCatalogService.isRecurrentPlacesVisible" class="button-container"></recurrent-places>
  </div> -->

  <!-- buscador, panel de locaciones y detalles de lacion -->
  <location-search-bar *ngIf="true" class="locaton-search-bar"></location-search-bar>
  <panel-locations
    [$Items]="$ItemsMap"
    (onCardClickedEmitter)="onFocusPin($event)"
    (onCardFilterEmitter)="onFilterMap($event)"
    *ngIf="isVisiblePanel"
  ></panel-locations>
  <panel-detail-locations></panel-detail-locations>
  <recurrent-places *ngIf="geoClustersFrecuencyCatalogService.isRecurrentPlacesVisible" class="button-container"></recurrent-places>

  <!-- cuadro para mostrar el street view al hacer clic en el mapa -->
  <div *ngIf="showStreetViewBox" class="info-box">
    <button class="close-btn" (click)="closeInfoBox()">x</button>
    <img (click)="openStreetView()" class="col-5" src="assets/img/street-view-bg.png" alt="Imagen">
    <div class="info-text col-9">
      <h3>{{ streetViewBoxTitle }}</h3>
      <p (click)="openStreetView()">{{ streetViewBoxDescription }}</p>
    </div>
  </div>

<!-- <popup-map [$isVisiblePopupMap] ="_isVisiblePopUpMap"></popup-map> -->
<!-- <button mat-button color="primary" class="btn-layers" (click)="onChangeBaseMap()" >{{ _baseMapText }}</button> -->
<!-- <button mat-button color="primary" class="btn-update" (click)="onUpdateMap()" >{{ _UpdateBtnText }}</button> -->
<basemap-selector class="map-selector-position"></basemap-selector>
</div>
